<template>
  <el-card
class="card-container"
shadow="never">
    <el-row
slot="header"
type="flex"
justify="space-between"
align="middle">
      <h1 class="card-container__title">Cài đặt quy trình ({{ data.length }})</h1>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        Thêm mới
      </el-button>
    </el-row>
    <el-table
header-row-class-name="table-header"
:data="data"
size="small">
      <el-table-column
        v-for="(c, index) in columns"
        :key="index"
        :prop="c.key"
        :label="c.label"
        :align="c.align"
        :width="c.width"
        :min-width="c.min_width"
      >
        <template slot-scope="scope">
          <span v-if="c.key === 'name'">
            {{ scope.row.contract_id | getContractName(allContracts) }}
          </span>
          <span v-else-if="c.key === 'steps'">
            {{ scope.row.contract_id | getStepsName(allContractSteps) }}
          </span>
          <span v-else>
            {{ scope.row[c.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <Buttons
            :item="scope.row"
            :buttons="['edit', 'delete']"
            @edit="(v) => handleUpdate(v)"
            @delete="(v) => handleDelete(v)"
          />
        </template>
      </el-table-column>
    </el-table>
    <ContractFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :contracts="data"
      :fields="fields"
      :all-contracts="allContracts"
      :all-contract-steps="allContractSteps"
      @close="formVisible = false"
      @save="handleSave"
    />
  </el-card>
</template>

<script>
import ContractFormPopup from "../../popups/ContractForm.vue";
import Buttons from "@/components/items/Buttons.vue";
import contractServices from "@/services/contract";
import contractStepServices from "@/services/contract-step";
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectContracts",
  components: {
    ContractFormPopup,
    Buttons,
  },
  props: {
    object: Object,
  },
  data() {
    return {
      selectedItem: null,
      formVisible: false,
      allContracts: [],
      allContractSteps: [],
    };
  },
  computed: {
    data() {
      return (this.object?.extra?.contracts || []).sort(
        (a, b) => a.order - b.order
      );
    },
    fields() {
      const data = this.object?.extra?.fields || [];
      return data;
    },
    columns() {
      return [
        {
          label: "Tên quy trình",
          key: "name",
          width: "400px"
        },
        {
          label: "Các bước",
          key: "steps",
        },
      ];
    },
    contractParams() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "-created",
        filters: {
          status: "enable",
          organization_id: this.object.extra?.organization_id
        }
      };
      return _params;
    },
    stepParams() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "+order",
        filters: {
          organization_id: this.object.extra?.organization_id
        }
      };
      return _params;
    },
  },
  beforeMount() {
    this.fetchAllContracts();
    this.fetchAllSteps();
  },
  methods: {
    fetchAllContracts() {
      contractServices
      .list(this.contractParams)
        .then((response) => {
          this.allContracts = response.items.map((c) => ({
            id: c.id,
            name: c.translations?.vi?.name
          }))
        })
        .catch(() => {
          this.allContracts = [];
        });
    },
    fetchAllSteps() {
      contractStepServices
      .list(this.stepParams)
        .then((response) => {
          this.allContractSteps = response.items.map((c) => ({
            id: c.id,
            contract_id: c.contract_id,
            name: c.translations?.vi?.name
          }))
        })
        .catch(() => {
          this.allContractSteps = [];
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        const contracts = this.data.filter((c) => c.contract_id !== item.contract_id);
        this.handleSave({
          payload: { contracts },
          success: () => {
            notification(this, "success", "delete", `cài đặt`);
          },
          error: () => {
            notification(this, "error", "delete", "cài đặt");
          },
        });
      });
    },
    handleSave(data = { payload: {}, success: () => {}, error: () => {} }) {
      this.$emit("save", {
        payload: data.payload,
        success: data.success,
        error: data.error,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
